import { Component } from '@angular/core';
import { MyProfileSidebarComponent } from './myprofile-sidebar/myprofile-sidebar.component';
import { MyProfileBoxComponent } from './myprofile-box/myprofile-box.component';

@Component({
  selector: 'app-myprofile',
  imports: [
    MyProfileSidebarComponent,
    MyProfileBoxComponent
  ],
  templateUrl: './myprofile.component.html',
  styleUrl: './myprofile.component.scss',
  standalone: true
})
export class MyProfileComponent {

}
